import React from 'react';
import {fromJS, Map} from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import {callAction} from 'client/framework';

import withTracking from 'lib/hocs/withTracking';

import CreateAssignmentRecipientStudents from '../CreateAssignmentRecipientStudents/CreateAssignmentRecipientStudents.react';
import createAssignmentActions from '../../CreateAssignment.actions';
import createAssignmentStore from '../../CreateAssignment.store';
import CreateAssignmentRecipientItem from '../CreateAssignmentRecipientItem/CreateAssignmentRecipientItem.react';

const CreateAssignmentRecipientGroup = withTracking(
  class TrackedCreateAssignmentsRecipientsGroup extends React.Component {
    static propTypes = {
      classroom: ImmutablePropTypes.record,
      trackEvent: PropTypes.func
    };

    componentDidUpdate() {
      callAction(createAssignmentActions.SET_ACTIVE_RECIPIENT_GROUP, null);
    }

    handleMultiSelect = (e) => {
      // As of ALBERT-4803, we only display one class at a time in edit mode. This prevents users from de-selecting it.
      if (createAssignmentStore.getIsEditMode()) {
        return;
      }

      // hack to fix a11y compliance (target is opposite of what it should be)
      const checked = e.which === 13 ? !e.target.checked : e.target.checked;

      const recipientData = new Map({
        addRecipients: checked,
        autoAssignNewEnrollees: checked,
        classroomId: this.props.classroom.getId(),
        classroomName: this.props.classroom.getName(),
        students: this.props.classroom.getStudents()
      });
      this.props.trackEvent({
        type: 'button',
        content: 'Classroom selected',
        event: 'click'
      });
      callAction(createAssignmentActions.SET_ACTIVE_RECIPIENT_GROUP, this.props.classroom.getId());
      callAction(createAssignmentActions.SET_MULTIPLE_RECIPIENTS, recipientData);
    };

    handleAutoAssignNewEnrolleesToggle = (e) => {
      const classroomId = this.props.classroom.getId();
      const recipientData = fromJS({
        classroomId,
        autoAssignNewEnrollees: e.target.checked
      });
      callAction(createAssignmentActions.SET_ACTIVE_RECIPIENT_GROUP, classroomId);
      callAction(createAssignmentActions.TOGGLE_AUTO_ASSIGN_NEW_CLASSROOM_ENROLLEES, recipientData);
    };

    render() {
      const selectedRecipients = createAssignmentStore.getSelectedRecipients();
      const {classroom} = this.props;
      const students = classroom.getStudents();
      const isClassroomSelected = selectedRecipients.has(classroom.getId());

      // Determine if classroom meets conditions for auto-assigning new enrollees in the future
      const totalEnrolledStudents = students.size;
      const emptyClassroom = totalEnrolledStudents === 0;
      let autoAssignNewEnrollees;
      // If this classroom is empty, we need to lock the auto-assign setting in the "On" position.
      if (emptyClassroom) {
        autoAssignNewEnrollees = true;
      } else {
        autoAssignNewEnrollees = selectedRecipients.getIn(
          [classroom.getId(), 'autoAssignNewEnrollees'],
          true
        );
      }

      return (
        <div className='acf__recipient-group'>
          <CreateAssignmentRecipientItem
            autoAssignNewEnrollees={autoAssignNewEnrollees}
            checked={isClassroomSelected}
            id={classroom.getId()}
            name={classroom.getName()}
            onAutoAssignNewEnrolleesToggle={this.handleAutoAssignNewEnrolleesToggle}
            onChange={this.handleMultiSelect}
            size={totalEnrolledStudents}
            toggleDisabled={emptyClassroom || !isClassroomSelected}
            value={classroom.getId()}
          >
            <CreateAssignmentRecipientStudents
              classroom={classroom}
              students={classroom.getStudents()}
            />
          </CreateAssignmentRecipientItem>
        </div>
      );
    }
  },
  {}
);

export default CreateAssignmentRecipientGroup;
